// Civic Lens Public Pages - Primer Brand UI
import React from 'react'
import { createRoot } from 'react-dom/client'

// Import Primer Brand CSS and fonts
import '@primer/react-brand/lib/css/main.css'
import '@primer/react-brand/fonts/fonts.css'

// Civic Lens public pages are built on @primer/react-brand, but a few shared
// components reused here (the AdminGateModal shown when a non-admin clicks
// Subscribe, via its @primer/react SubscriptionModal shell) reference @primer/react
// "functional" color tokens (--fgColor-*, --bgColor-muted, etc.). Those tokens are
// not part of react-brand's CSS, so without this they resolve to nothing and the
// modal renders colorless. This file defines them with direct light-theme values,
// scoped to [data-color-mode="light"][data-light-theme="light"] — already set on
// the civic_lens_logged_out <body> — so it only adds variables and does not restyle
// any react-brand element.
import '@primer/primitives/dist/css/functional/themes/light.css'

// Import our Civic Lens components
import CivicLensApp from '../civic_lens/CivicLensApp'

document.addEventListener('DOMContentLoaded', () => {
  const rootElement = document.getElementById('civic-lens-root')
  if (rootElement) {
    const pageData = JSON.parse(rootElement.dataset.page || '{}')
    const root = createRoot(rootElement)
    root.render(<CivicLensApp {...pageData} />)
  }
})
